import { useMutation } from '@tanstack/react-query';

import { PostDeleteDeliveryEndpointPayload, PostDeleteDeliveryEndpointResponse } from '@/api/sofarApi/types';
import { axios } from '@/common/axios';
import { MutationConfig, queryClient } from '@/common/react-query';

export const postDeleteDeliveryEndpoint = (
    payload: PostDeleteDeliveryEndpointPayload
): Promise<PostDeleteDeliveryEndpointResponse> => {
    return axios.post('/fetch/delete-delivery-endpoint', payload);
};

type UsePostDeleteDeliveryEndpointOptions = {
    config?: MutationConfig<typeof postDeleteDeliveryEndpoint>;
    data?: PostDeleteDeliveryEndpointPayload;
};

export const usePostDeleteDeliveryEndpoint = ({ config }: UsePostDeleteDeliveryEndpointOptions = {}) => {
    return useMutation({
        ...config,
        mutationFn: postDeleteDeliveryEndpoint,
        onSuccess: () => queryClient.invalidateQueries({ queryKey: ['sofar-api-delivery-endpoints'] }),
    });
};
